import Asset from './AssetTypes/Asset';
import ImageAsset from './AssetTypes/ImageAsset';
import AudioAsset from './AssetTypes/AudioAsset';
import AssetLoaderInfo from './AssetLoaderInfo';
import Fontasset from './AssetTypes/FontAsset';

class AssetManager {
    constructor() {
        window.AssetManager = this;
        this._dictionary = {};
        this._assets = [];
    }

    _getIndex(item) {
        for (let i = 0; i < this._assets.length; i++) {
            const asset = this._assets[i];
            if (asset === item) {
                return i;
            }
        }
        return -1;
    }

    // Load an asset by url. (async)
    // onLoad(asset : Asset)
    // onError(asset : Asset, error)
    load(id, url, onLoad, onError) {
        if (this._dictionary[id]) {
            throw new Error(`Asset with ID ${  id  } has already been loaded.`);
        }
        const urlExtension = url.split('.').pop();
        const type = AssetManager.typeDictionary[urlExtension];
        if (type == null) {
            if (onError) onError({ error: `No resource type found for extension "${urlExtension}" for resource "${url}".` });
            else throw new Error(`No resource type found for extension "${urlExtension}" for resource "${url}".`);
        }
        const newAsset = new type();
        const assetManager = this;

        newAsset.load(
            id,
            url,
            asset => {
                assetManager._dictionary[id] = asset;
                assetManager._assets.push(asset);
                if (onLoad) onLoad(asset);
            },
            error => {
                if (onError) onError(newAsset, error);
                else console.error(error);
            }
        );
    }

    // Load all the assets from an asset database. Returns an AssetLoaderInfo object to keep track of the progress. (async)
    // onFinish(loaderInfo : AssetLoaderInfo)
    loadDatabase(db, onFinish) {
        const errors = {};
        const loaderInfo = new AssetLoaderInfo(db.length);

        const checkFinished = function() {
            if (loaderInfo.loadCount >= loaderInfo.toLoadCount) {
                if (onFinish) onFinish(loaderInfo);
            }
        };
        const onLoad = function(asset) {
            loaderInfo.lastLoadedAssetId = asset.id;
            loaderInfo.lastLoadedAssetStatus = AssetLoaderInfo.Status.Loaded;
            loaderInfo.loadedAssets.push(asset);
            loaderInfo.loadCount++;
            loaderInfo.onLoaded();
            checkFinished();
        };
        const onError = function(asset, error) {
            loaderInfo.lastLoadedAssetId = asset.id;
            loaderInfo.lastLoadedAssetStatus = AssetLoaderInfo.Status.Failed;
            loaderInfo.errors.push(error);
            loaderInfo.loadCount++;
            loaderInfo.onLoaded();
            checkFinished();
        };

        for (let i = 0; i < db.length; i++) {
            loaderInfo.lastLoadedAssetId = db[i].id;
            loaderInfo.lastLoadedAssetStatus = AssetLoaderInfo.Status.Query;

            this.load(db[i].id, db[i].url, onLoad, onError);
        }
        return loaderInfo;
    }

    // Retrieve a resource from the loaded resources.
    retrieveLoaded(id) {
        const candidate = this._dictionary[id];
        if (candidate == null) {
            throw new Error(`Asset with ID "${id}" does not exist.`);
        }
        return this._dictionary[id];
    }

    // Retrieve a resource from the loaded resources and return directly its data.
    get(id) {
        return this.retrieveLoaded(id).get();
    }

    // Unload a specific item by the resource id.
    unload(id) {
        const item = this._dictionary[id];
        if (item) {
            const index = this._getIndex(item);
            if (index >= 0) {
                delete this._dictionary[item.id];
                this._assets.splice(index, 1);
                item.unload();
            }
        }
    }
}

AssetManager.typeDictionary = {
    png: ImageAsset,
    jpg: ImageAsset,
    gif: ImageAsset,
    mp3: AudioAsset,
    ttf: Fontasset
};

export default new AssetManager();
